/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Downgrade_Overage_ControlsInputs */



/**
* | output |
* | --- |
* | "Overage controls & quotas" |
*
* @param {Sub_Downgrade_Overage_ControlsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_downgrade_overage_controls = /** @type {((inputs?: Sub_Downgrade_Overage_ControlsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Downgrade_Overage_ControlsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Überschreitungskontrollen & Kontingente")
	return /** @type {LocalizedString} */ ("Overage controls & quotas")
});